angular.module( 'acme.view.application.themes.donation.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.themes.donation.create.controllers',
  'acme.view.application.themes.donation.modals.editValue.controllers',
  'acme.view.application.themes.donation.modals.deactivate.controllers',
  'acme.view.application.dataGrid.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var themesDonationCreate = {
        name: 'application.themes.donationCreate',
        url: '/config/donation/create/:id',
        params: {
          id: null,
        },
        views: {
          "subview-main": {
            controller: 'ThemesDonationCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/themes/donation/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Theme - Donations - Edit Theme Override',
          enablePreferences: true
        },
        resolve: {
          ThemesData: [
            'AuthService',
            'ApiService',
            function(AuthService, ApiService) {
              return ApiService.themes.detail(true);
            }
          ]
        }
      };

    $stateProvider
      .state(themesDonationCreate);
});
